/* eslint-disable react-hooks/exhaustive-deps */
import axios from "axios";
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Spinner from "../../Spinner";

const PaymentStatus = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get("orderId");
  const domainname = window.location.hostname;

  const userAddress = JSON.parse(localStorage.getItem("address"));
  const userProductData = JSON.parse(localStorage.getItem("slectedData"));

  const createOrder = async (transitionId, amount) => {
    if (!userAddress || !userProductData) {
      console.error("Missing address or product data in localStorage.");
      navigate("/cart");
      return;
    }

    try {
      const orderData = {
        orderId,
        products: userProductData,
        address: userAddress,
        transitionId,
        amount,
        domainname,
      };

      const res = await axios.post(
        `${process.env.REACT_APP_PAYMENT_NODE_URL}/api/order`,
        orderData
      );

      if (res.status === 200 || res.status === 201) {
        navigate(`/thankyou?txnId=${orderId}`);
      } else {
        console.warn("Unexpected status from order API:", res.status);
        navigate("/cart");
      }
    } catch (error) {
      console.error("Order creation failed:", error);
      navigate("/cart");
    }
  };

  useEffect(() => {
    const verifyPayment = async () => {
      if (!orderId) return;

      const PAYMENT_TYPE = process.env.REACT_APP_PAYMENT_TYPE;
      const BASE_URL = process.env.REACT_APP_PAYMENT_NODE_URL;

      try {
        if (PAYMENT_TYPE === "phonepe") {
          const res = await axios.get(
            `${BASE_URL}/api/phonepay/sdk/order-status/${orderId}`
          );
          const data = res?.data;

          if (data?.state === "COMPLETED") {
            const transitionId =
              data?.paymentDetails?.[0]?.transactionId || null;
            const amount = data?.amount / 100 || 0
            await createOrder(transitionId, amount);
          } else {
            navigate("/cart");
          }
        }
      } catch (error) {
        console.error("Payment verification error:", error);
        navigate("/cart");
      }
    };

    verifyPayment();
  }, [orderId, navigate]);

  return <Spinner />;
};

export default PaymentStatus;
